import { useAccountRepository } from '@frontend/repository';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useAccessControllers = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const location = useLocation();
    const navigate = useNavigate();

    return {
        dispatch,
        currentAccount,
        location,
        navigate
    };
};
